/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Rolodex_FirmDetail_AffectedLiveOfferingsQueryVariables = Types.Exact<{
  firmId: Types.Scalars['UUID']['input'];
}>;

export type Rolodex_FirmDetail_AffectedLiveOfferingsQuery = {
  readonly __typename?: 'Query';
  readonly listLiveOfferingsAffectedByFirmHierarchyUnlink: ReadonlyArray<{
    readonly __typename?: 'LiveOfferingsAffectedByFirmHierarchyUnlink';
    readonly cmgEntityKey: string;
    readonly issuerNamesWithStockSymbols: ReadonlyArray<{
      readonly __typename?: 'IssuerNameWithStockSymbol';
      readonly issuerName: string;
      readonly stockSymbol?: string | null;
    }>;
  }>;
};

export const Rolodex_FirmDetail_AffectedLiveOfferingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Rolodex_FirmDetail_AffectedLiveOfferings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listLiveOfferingsAffectedByFirmHierarchyUnlink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firmId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuerNamesWithStockSymbols' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'issuerName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stockSymbol' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRolodex_FirmDetail_AffectedLiveOfferingsQuery__
 *
 * To run a query within a React component, call `useRolodex_FirmDetail_AffectedLiveOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolodex_FirmDetail_AffectedLiveOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolodex_FirmDetail_AffectedLiveOfferingsQuery({
 *   variables: {
 *      firmId: // value for 'firmId'
 *   },
 * });
 */
export function useRolodex_FirmDetail_AffectedLiveOfferingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Rolodex_FirmDetail_AffectedLiveOfferingsQuery,
    Rolodex_FirmDetail_AffectedLiveOfferingsQueryVariables
  > &
    (
      | { variables: Rolodex_FirmDetail_AffectedLiveOfferingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Rolodex_FirmDetail_AffectedLiveOfferingsQuery,
    Rolodex_FirmDetail_AffectedLiveOfferingsQueryVariables
  >(Rolodex_FirmDetail_AffectedLiveOfferingsDocument, options);
}
export function useRolodex_FirmDetail_AffectedLiveOfferingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Rolodex_FirmDetail_AffectedLiveOfferingsQuery,
    Rolodex_FirmDetail_AffectedLiveOfferingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Rolodex_FirmDetail_AffectedLiveOfferingsQuery,
    Rolodex_FirmDetail_AffectedLiveOfferingsQueryVariables
  >(Rolodex_FirmDetail_AffectedLiveOfferingsDocument, options);
}
// @ts-ignore
export function useRolodex_FirmDetail_AffectedLiveOfferingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Rolodex_FirmDetail_AffectedLiveOfferingsQuery,
    Rolodex_FirmDetail_AffectedLiveOfferingsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  Rolodex_FirmDetail_AffectedLiveOfferingsQuery,
  Rolodex_FirmDetail_AffectedLiveOfferingsQueryVariables
>;
export function useRolodex_FirmDetail_AffectedLiveOfferingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Rolodex_FirmDetail_AffectedLiveOfferingsQuery,
        Rolodex_FirmDetail_AffectedLiveOfferingsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  Rolodex_FirmDetail_AffectedLiveOfferingsQuery | undefined,
  Rolodex_FirmDetail_AffectedLiveOfferingsQueryVariables
>;
export function useRolodex_FirmDetail_AffectedLiveOfferingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Rolodex_FirmDetail_AffectedLiveOfferingsQuery,
        Rolodex_FirmDetail_AffectedLiveOfferingsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Rolodex_FirmDetail_AffectedLiveOfferingsQuery,
    Rolodex_FirmDetail_AffectedLiveOfferingsQueryVariables
  >(Rolodex_FirmDetail_AffectedLiveOfferingsDocument, options);
}
export type Rolodex_FirmDetail_AffectedLiveOfferingsQueryHookResult = ReturnType<
  typeof useRolodex_FirmDetail_AffectedLiveOfferingsQuery
>;
export type Rolodex_FirmDetail_AffectedLiveOfferingsLazyQueryHookResult = ReturnType<
  typeof useRolodex_FirmDetail_AffectedLiveOfferingsLazyQuery
>;
export type Rolodex_FirmDetail_AffectedLiveOfferingsSuspenseQueryHookResult = ReturnType<
  typeof useRolodex_FirmDetail_AffectedLiveOfferingsSuspenseQuery
>;
export type Rolodex_FirmDetail_AffectedLiveOfferingsQueryResult = Apollo.QueryResult<
  Rolodex_FirmDetail_AffectedLiveOfferingsQuery,
  Rolodex_FirmDetail_AffectedLiveOfferingsQueryVariables
>;
